import React from "react";
import Footerhead from "../components/Footerhead";

const PrivacyPolicy = () => {

  return (
    <>
      <div className="legalPageLayout container">
        <div className="row">
          <div className="col-12">
            <h1>PRIVACY POLICY</h1>
            <p>Toola Finance<br />Updated: November 2, 2024</p>

            <h2>Privacy Policy for Toola - AI-Powered Bookkeeping Services</h2>
            <p>At Toola ("we," "our," "us"), your privacy is important to us. This Privacy Policy explains how we collect, use, store, and protect your personal and business information when you use our AI-powered bookkeeping services ("Services"). By using our Services, you agree to the practices described in this Privacy Policy.<br />If you have any questions or concerns about how we handle your information, please contact us at <a href="mailto:contact@toola.in">contact@toola.in</a>.</p>

            <h3>1. Information We Collect</h3>
            <p>When you use our Services, we collect various types of information to provide and enhance the services we offer. The types of information we collect include:</p>

            <h4>1.1 Personal Information</h4>
            <p>When you sign up for an account or use our Services, we may collect personal information, such as:</p>
            <ul>
              <li><strong>Contact Details:</strong> Name, email address, phone number, and physical address.</li>
              <li><strong>Account Credentials:</strong> Username, password, and other registration details you provide.</li>
              <li><strong>Payment Information:</strong> Credit card or billing information for processing payments for our Services.</li>
            </ul>

            <h4>1.2 Business Information</h4>
            <p>If you use our Services for business purposes, we may collect business-related information, such as:</p>
            <ul>
              <li><strong>Business Profile:</strong> Company name, legal structure, tax ID, and other business details.</li>
              <li><strong>Financial Data:</strong> Bank statements, invoices, receipts, tax records, and other financial documents necessary for providing bookkeeping services.</li>
            </ul>

            <h4>1.3 Financial Data Processed by AI</h4>
            <p>As part of our AI-powered bookkeeping, we process your financial data to provide insights, generate reports, and automate tasks. This data may include:</p>
            <ul>
              <li><strong>Transactions and Financial History:</strong> Record of payments, invoices, expenses, and revenue.</li>
              <li><strong>Generated Reports:</strong> AI-generated financial reports and accounting summaries.</li>
            </ul>

            <h4>1.4 Usage Data</h4>
            <p>We collect technical and usage information to improve the performance and functionality of our platform, including:</p>
            <ul>
              <li><strong>Device and Browser Information:</strong> IP address, browser type, and device details.</li>
              <li><strong>Usage Patterns:</strong> Interaction data, such as the pages you visit, time spent on our platform, and other activities within the Services.</li>
            </ul>

            <h4>1.5 Cookies and Tracking Technologies</h4>
            <p>We use cookies and similar technologies to gather information about your interactions with our website and Services. This data helps us improve user experience and ensure smooth operation. You can manage your cookie preferences in your browser settings.</p>

            <h3>2. How We Use Your Information</h3>
            <p>We use the information we collect to deliver, improve, and personalize our Services. Specifically, we use your data for the following purposes:</p>

            <h4>2.1 To Provide and Manage Our Services</h4>
            <p>We use your personal and business information to:</p>
            <ul>
              <li>Process and manage your financial records and transactions.</li>
              <li>Automate bookkeeping tasks and generate reports.</li>
              <li>Provide customer support and address any service-related issues.</li>
            </ul>

            <h4>2.2 To Personalize Your Experience</h4>
            <p>We use your data to:</p>
            <ul>
              <li>Customize our platform according to your business needs and preferences.</li>
              <li>Offer tailored recommendations and insights based on your financial data.</li>
            </ul>

            <h4>2.3 To Process Payments</h4>
            <p>We use payment details to:</p>
            <ul>
              <li>Process payments for your subscription or use of our Services.</li>
              <li>Manage billing and account-related queries.</li>
            </ul>

            <h4>2.4 To Improve Our Platform</h4>
            <p>We analyze usage data to:</p>
            <ul>
              <li>Enhance the functionality and security of our platform.</li>
              <li>Identify and fix any bugs, glitches, or performance issues.</li>
            </ul>

            <h4>2.5 To Communicate with You</h4>
            <p>We may send you:</p>
            <ul>
              <li>Service-related notifications, updates, or alerts regarding your account.</li>
              <li>Promotional materials or offers, if you have opted to receive them.</li>
            </ul>
            <p>You can opt out of marketing communications at any time by following the unsubscribe instructions in those emails.</p>

            <h3>3. Sharing Your Information</h3>
            <p>We do not sell, rent, or trade your personal or business data to third parties. However, we may share your information in the following situations:</p>

            <h4>3.1 Service Providers</h4>
            <p>We may share your information with trusted third-party service providers who assist us in providing our Services, such as:</p>
            <ul>
              <li>Payment processors</li>
              <li>Cloud storage providers</li>
              <li>Customer support tools</li>
            </ul>
            <p>These service providers are bound by strict confidentiality agreements and are only allowed to use your information to perform specific tasks related to our Services.</p>

            <h4>3.2 Legal Obligations</h4>
            <p>We may disclose your information if required by law or if necessary to:</p>
            <ul>
              <li>Comply with legal obligations, regulations, or court orders.</li>
              <li>Enforce our Terms of Service or protect our rights, privacy, safety, or property.</li>
            </ul>

            <h4>3.3 Business Transfers</h4>
            <p>In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of the transaction. We will notify you in advance if this happens.</p>

            <h4>3.4 Anonymized Data</h4>
            <p>We may use anonymized or aggregated data for analytical purposes, business analysis, or marketing. This data will not identify you personally.</p>

            <h3>4. Data Security</h3>
            <p>We take the security of your data seriously and use a combination of technical and organizational measures to protect it. These include:</p>
            <ul>
              <li><strong>Encryption:</strong> We use encryption to secure sensitive data during transmission (e.g., SSL/TLS).</li>
              <li><strong>Access Control:</strong> We restrict access to your data to authorized personnel only.</li>
              <li><strong>Security Protocols:</strong> We implement industry-standard security practices to safeguard your information.</li>
            </ul>
            <p>However, no method of transmission over the Internet or electronic storage is 100% secure. While we strive to protect your information, we cannot guarantee absolute security.</p>

            <h3>5. Data Retention</h3>
            <p>We retain your personal and business data for as long as necessary to fulfill the purposes outlined in this Privacy Policy, such as providing our Services, complying with legal obligations, and resolving disputes.</p>
            <p>If you choose to close your account, we may retain some information for a limited period as required by law or for legitimate business purposes, but we will securely delete or anonymize any unnecessary data.</p>

            <h3>6. Your Rights and Choices</h3>
            <p>Depending on your location, you may have the following rights with respect to your personal data:</p>
            <ul>
              <li><strong>Access:</strong> Request a copy of the personal data we hold about you.</li>
              <li><strong>Correction:</strong> Request correction of any inaccurate or incomplete information.</li>
              <li><strong>Deletion:</strong> Request deletion of your personal data, subject to certain legal exceptions.</li>
              <li><strong>Opt-Out of Marketing:</strong> You can opt out of receiving marketing communications from us by following the instructions in the emails or by contacting us directly.</li>
            </ul>
            <p>To exercise any of these rights, please contact us at <a href="mailto:contact@toola.in">contact@toola.in</a>.</p>

            <h3>7. Transfers of Data</h3>
            <p>As a global business, we may transfer your data to other countries. This may include transferring your data to jurisdictions that may not offer the same level of data protection as your home country. However, we take steps to ensure your data is handled securely, in accordance with applicable laws. As per the country jurisdiction laws (add point)</p>

            <h3>8. Changes to This Privacy Policy</h3>
            <p>We may update this Privacy Policy from time to time. When we make changes, we will update the "Last updated" date at the top of this page. We encourage you to review this Privacy Policy periodically to stay informed about how we protect your information.</p>

            <h3>9. Contact Us</h3>
            <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:<br />Email: <a href="mailto:contact@toola.in">contact@toola.in</a>.</p>

            <h3>10. Governing Law</h3>
            <p>This Privacy Policy is governed by the laws of India. Any disputes related to this Privacy Policy will be resolved in the courts of Hyderabad, Telangana.</p>

            <p>This Privacy Policy aims to be clear and transparent about how we handle your data while complying with relevant privacy regulations. If you need specific legal advice, please consult with a legal professional.</p>
          </div>
        </div>
      </div>
      
      <section className="container ">
        <Footerhead />
      </section>

    </>
  );
};

export default PrivacyPolicy;
